module.exports = __webpack_public_path__ + "img/sld_mfm_acb_ta1_b1.0887e7b2.svg";